export const DESKTOP_BREAKPOINT = 1024;
export const MIDDLE_SIZE_BREAKPOINT = 760;
export const SMALL_MOBILE_BREAKPOINT = 667;
export const TABLET_BREAKPOINT = 960;
